import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabButtonFn = /* @__PURE__ */ createRecipe('rp-tab-button', {}, [])

const tabButtonVariantMap = {}

const tabButtonVariantKeys = Object.keys(tabButtonVariantMap)

export const tabButton = /* @__PURE__ */ Object.assign(memo(tabButtonFn), {
  __recipe__: true,
  __name__: 'tabButton',
  raw: (props) => props,
  variantKeys: tabButtonVariantKeys,
  variantMap: tabButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabButtonVariantKeys)
  },
})